{
  "Addusertitle": "Aggiungere l'account utente dell'applicazione",
  "Modifyusertitle": "Modifica dell'account utente dell'applicazione",
  "PermissionsTitle": "Permessi",
  "ExtensionTitle": "Estensione\/Punto finale",
  "ReportingTitle": "Segnalazione",
  "AdministratorTitle": "Amministratore",
  "RoleTitle": "Ruolo",
  "SettingsTitle": "Impostazioni",
  "ValidationWarning": "Correggere gli errori prima di terminare",
  "ServerErrorTitle": "Errori di convalida",
  "MonthlyBillingWarning": "AVVERTENZA: influisce sulla fatturazione mensile",
  "UnknownOrDeleted": "[Sconosciuto o cancellato]",
  "AddUserLanguage_ButtonHelpLabel": "Aiuto?",
  "AddUserLanguage_ButtonSubmitLabel": "Risparmiare",
  "AddUserLanguage_ButtonCancelLabel": "Annullamento",
  "AddUserLanguage_PromptMessage": "Siete sicuri di voler chiudere questa finestra? Tutte le configurazioni modificate andranno perse una volta chiuse.",
  "AddUserLanguage_PromptConfirm": "Sì",
  "AddUserLanguage_PromptCancel": "Annullamento",
  "AddUserLanguage_DetailsTitle": "Dettagli utente",
  "NAME": "AddUserLanguage",
  "APIKeys_Title": "Chiavi API"
}